import { useInfiniteQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useServicesPerformed = (req, options = {}) => {
  return useInfiniteQuery({
    queryKey: [
      req.order,
      req.by,
      req.categoryIds,
      req.clinicsIds,
      req.provider_id,
      req.serviceIds,
      req.fromDate,
      req.toDate,
    ],
    queryFn: async ({ pageParam = 1 }) => {
      return http.get(HTTP_ENDPOINTS.getServiceSales(), {
        params: {
          fromDate: req.fromDate,
          toDate: req.toDate,
          clinicsIds: req.clinicsIds,
          categoryIds: req.categoryIds,
          serviceIds: req.serviceIds,
          provider_id: req.provider_id,
          page: pageParam,
          orderBy: req.by,
          order: req.order,
        },
      });
    },
    ...options,
    getNextPageParam: (_lastPage, pages) => {
      const lastPage = pages[0].data.data.last_page;
      if (pages.length < lastPage) {
        return pages.length + 1;
      }
      return null;
    },
  });
};
